<template>
  <!-- 各州每日操作日报 -->
  <div class="Box">
    <el-form label-position="top">
      <el-row justify="start" style="flex-wrap: wrap;align-items: center" type="flex">
        <el-col :span="8">
          <el-form-item label="日期 Data">
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              :end-placeholder="$t('collectionCenter.EndTime')"
              :range-separator="$t('collectionCenter.to')"
              :start-placeholder="$t('collectionCenter.StartTime')"
              style="width: 90%"
              type="daterange"
              value-format="yyyy-MM-dd"
              @change="dateChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="大区 Região">
            <el-select
              v-model="queryForm.params.regionId"
              :placeholder="$t('placeOrder.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 90%"
              @change="regionChange"
            >
              <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="网点所属州 Estado do ponto">
            <el-select
              v-model="queryForm.params.state"
              :placeholder="$t('placeOrder.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 90%"
            >
              <el-option
                v-for="(item, idx) in stateOptionList"
                :key="idx"
                :label="item.shortName"
                :value="item.shortName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--搜索-->
          <el-button
            icon="el-icon-search" size="small" type="primary"
            @click="searchClick"
          >{{ $t('newOrder.search') }}
          </el-button>
          <!--重置-->
          <el-button
            icon="el-icon-refresh-left" size="small" type="info"
            @click="defaultClick"
          >{{ $t('newOrder.reset') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-divider />
    <el-button size="small" type="primary" @click="exportClick">{{ $t('newOrder.export') }}</el-button>
    <el-table
      :data="processedTableData"
      :span-method="objectSpanMethod"
      border
      style="width: 100%; margin-top: 10px"
    >
      <el-table-column
        v-for="column in tableColumns"
        :key="column.prop"
        :label="column.label"
        :prop="column.prop"
        :width="column.width"
        align="center"
        header-align="center"
      />
    </el-table>
    <div class="right">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[100, 200, 400,500,1000]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="searchClick1"
        @size-change="searchClick"
      />
    </div>
  </div>
</template>

<script>
import { regionQueryList, selectState, stateOpsReportExport, stateOpsReportPage } from '@/api/orderApi';
import dayjs from 'dayjs';
import { goRWExportList } from '@/utils/goExportList.js';

export default {
  name: 'StateDailyOperationReport',
  data() {
    return {
      timeValue: [],
      queryForm: {
        pageSize: 100,
        pageNumber: 1,
        params: {}
      },
      regionList: [],
      stateOptionList: [],
      tableData: [],
      total: 0,
      spanArr: [],
      pos: 0
    };
  },
  computed: {
    // 需要动态展示表格列，方便合并行
    tableColumns() {
      return [
        { prop: 'dataDate', label: '日期 Data', width: '100' },
        { prop: 'region', label: '大区 Região', width: '180' },
        { prop: 'state', label: '网点所属州 Estado do ponto', width: '180' },
        { prop: 'collectScanQuantity', label: '揽收票数 Qtd. de coleta', width: '180' },
        { prop: 'collectLoadQuantity', label: '揽收装车票数 Qtd. de carregamento da coleta', width: '200' },
        { prop: 'firstUnsealVehicleQuantity', label: '一级分拨中心解封车票数 Qtd. de desbloqueio do HUB1', width: '200' },
        { prop: 'firstReceiptQuantity', label: '一级分拨中心到件票数 Qtd. de entrada do HUB1', width: '200' },
        { prop: 'firstSendQuantity', label: '一级分拨中心发件票数 Qtd. de saída do HUB1', width: '200' },
        { prop: 'firstSealVehicleQuantity', label: '一级分拨中心封车票数 Qtd. de bloqueio do HUB1', width: '200' },
        {
          prop: 'secondUnsealVehicleQuantity',
          label: '二级分拨中心解封车票数 Qtd. de desbloqueio do HUB2',
          width: '200'
        },
        { prop: 'transferInStorageQuantity', label: '二级分拨中心到件票数 Qtd. de entrada do HUB2', width: '200' },
        { prop: 'transferOutStorageQuantity', label: '二级分拨中心发件票数 Qtd. de saída do HUB2', width: '200' },
        { prop: 'secondSealVehicleQuantity', label: '二级分拨中心封车票数 Qtd. de bloqueio do HUB2', width: '200' },
        { prop: 'thirdUnsealVehicleQuantity', label: '三级分拨中心解封车票数 Qtd. de desbloqueio do HUB3', width: '200' },
        { prop: 'thirdTransferInStorageQuantity', label: '三级分拨中心到件票数 Qtd. de entrada do HUB3', width: '200' },
        { prop: 'thirdTransferOutStorageQuantity', label: '三级分拨中心发件票数 Qtd. de saída do HUB3', width: '200' },
        { prop: 'dispatchReceiptQuantity', label: '网点入库票数 Qtd. de entrada do ponto', width: '200' },
        { prop: 'lastDeliveryQuantity', label: '派件票数 Qtd. de entrega', width: '180' },
        { prop: 'deliveredQuantity', label: '签收票数 Qtd. de assinatura', width: '180' },
        { prop: 'punctualDeliveredQuantity', label: '准时签收票数 Qtd. de assinatura pontuais', width: '200' },
        { prop: 'timeoutDeliveredQuantity', label: '超时签收票数 Qtd. de assinatura atrasadas', width: '200' },
        { prop: 'timeoutQuantity', label: '超时票数 Qtd. de atrasos', width: '180' },
        { prop: 'problemQuantity', label: '问题件登记票数 Qtd. de anomalias', width: '180' }
      ];
    },
    totalFields() {
      const excludeFields = ['dataDate', 'region', 'state'];
      return this.tableColumns
        .map(column => column.prop)
        .filter(prop => !excludeFields.includes(prop));
    },
    processedTableData() {
      // 按日期和大区进行分组
      const groupedData = [];
      let currentGroup = null;

      this.tableData.forEach(item => {
        // 判断是否需要创建新组（第一个元素或与前一个元素的日期/大区不同）
        if (!currentGroup ||
          currentGroup.date !== item.dataDate ||
          currentGroup.region !== item.region) {
          currentGroup = {
            date: item.dataDate,
            region: item.region,
            items: [item]
          };
          groupedData.push(currentGroup);
        } else {
          // 同一组，直接添加
          currentGroup.items.push(item);
        }
      });

      // 为每组生成结果数据（包含总计行和原始数据行）
      const result = [];
      groupedData.forEach((group, groupIndex) => {
        // 如果组内有多于1条数据，则添加总计行
        if (group.items.length > 1) {
          const totalItem = this.calculateTotal(group.items);
          totalItem.dataDate = group.date;
          totalItem.region = group.region;
          totalItem.state = this.$t('GlobalSetObj.Total'); // 第三列显示"总计"
          totalItem.isTotalRow = true; // 标记为总计行，便于样式处理
          result.push(totalItem);
        }

        // 添加原始数据行
        group.items.forEach(item => {
          result.push(item);
        });
      });

      // 第一行展示为“-”占位
      if (result.length > 0 && !result[0].isTotalRow) {
        result[0].state = '-';
      }
      // 在数据更新后重新计算跨行信息
      this.$nextTick(() => {
        this.getSpanArr(result);
      });
      console.log('处理后的result==============', result);

      return result;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.processedTableData && this.processedTableData.length > 0) {
        this.getSpanArr(this.processedTableData);
      }
    });
  },
  created() {
    this.defaultClick();
  },
  methods: {
    regionChange(newVal) {
      // 大区为多选时，获取所选大区下的所有州
      this.queryForm.params.state = [];
      if (!newVal || newVal.length === 0 || this.regionList.length === 0) {
        this.stateOptionList = [];
        this.getState();
        return;
      }
      const allStates = [];
      newVal.forEach(regionId => {
        const selectedRegion = this.regionList.find(item => item.id === regionId);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          // 将州列表添加到总列表中
          selectedRegion.states.forEach(state => {
            // 避免重复添加
            if (!allStates.some(s => s.shortName === state)) {
              allStates.push({
                shortName: state
              });
            }
          });
          this.stateOptionList = allStates;
        }
      });
    },
    // 大区
    getRegion() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    getState() {
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name: '',
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.stateOptionList = res.data.records;
        }
      });
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.params.beginDate = '';
        this.queryForm.params.endDate = '';
        return;
      }
      this.queryForm.params.beginDate = val[0];
      this.queryForm.params.endDate = val[1];
    },
    defaultClick() {
      const d = new Date();
      const today = dayjs(d).format('YYYY-MM-DD');
      this.timeValue = [today, today];
      this.queryForm.params = {
        beginDate: today,
        endDate: today,
        regionId: [],
        state: []
      };
      this.getRegion();
      this.getState();
      this.searchClick();
    },
    searchClick1() {
      stateOpsReportPage(this.queryForm).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.$nextTick(() => {
            this.getSpanArr(this.processedTableData);
          });
        }
      });
    },
    searchClick() {
      this.queryForm.pageNumber = 1;
      this.searchClick1();
    },
    exportClick() {
      stateOpsReportExport(this.queryForm.params).then(res => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },

    /**
     * 对表格展示做处理
     */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (!this.spanArr || this.spanArr.length <= rowIndex) {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
      // 第一列（日期）合并
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex] ? this.spanArr[rowIndex].rowspan1 : 1;
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
      // 第二列（大区）合并
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex] ? this.spanArr[rowIndex].rowspan2 : 1;
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
      return {
        rowspan: 1,
        colspan: 1
      };
    },
    getSpanArr(data) {
      if (!data || !Array.isArray(data) || data.length === 0) {
        this.spanArr = [];
        return;
      }
      this.spanArr = [];
      this.pos = 0;
      // 初始化每行的跨行 [{rowspan1, rowspan2}, ...]
      const spanData = data.map(() => ({ rowspan1: 0, rowspan2: 0 }));
      // 用于跟踪日期和大区的组合位置
      let datePos = 0;
      let regionPos = 0;
      data.forEach((item, index) => {
        if (index === 0) {
          spanData[index].rowspan1 = 1;
          spanData[index].rowspan2 = 1;
          datePos = 0;
          regionPos = 0;
        } else {
          // 判断当前元素与上一个元素的日期和大区是否相同
          if (data[index].dataDate === data[index - 1].dataDate) {
            spanData[datePos].rowspan1 += 1;
            spanData[index].rowspan1 = 0;
          } else {
            spanData[index].rowspan1 = 1;
            datePos = index;
          }

          // 处理大区列合并 - 只有在日期相同的情况下才合并大区
          if (data[index].dataDate === data[index - 1].dataDate &&
            data[index].region === data[index - 1].region) {
            spanData[regionPos].rowspan2 += 1;
            spanData[index].rowspan2 = 0;
          } else {
            spanData[index].rowspan2 = 1;
            regionPos = index;
          }
        }
      });
      this.spanArr = spanData;
    },
    calculateTotal(items) { // 同步表格列
      const total = {};
      this.totalFields.forEach(field => {
        total[field] = items.reduce((sum, item) => sum + (item[field] || 0), 0);
      });
      return total;
    }
  }
};
</script>

<style lang="scss" scoped>
.Box {
  padding: 20px;
  box-sizing: border-box;
}

.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.Box ::v-deep .el-divider {
  margin: 10px !important;
}
</style>
